// Mock data for ADP Motors & Recovery website

export const businessInfo = {
  name: "ADP Motors & Recovery",
  phone: "07803 539815",
  email: "Adpmotors@outlook.com",
  coverageArea: "Nationwide Coverage",
  tagline: "Your Trusted Partner in Vehicle Recovery",
  description: "Professional, reliable, and dedicated vehicle recovery services across the UK"
};

export const services = [
  {
    id: 1,
    title: "24/7 Breakdown Recovery",
    description: "Round-the-clock emergency breakdown recovery service. We're always ready to help you get back on the road, any time of day or night.",
    icon: "clock"
  },
  {
    id: 2,
    title: "Vehicle Towing",
    description: "Professional vehicle towing services for all types of vehicles. Safe, secure transportation to your destination of choice.",
    icon: "truck"
  },
  {
    id: 3,
    title: "Roadside Assistance",
    description: "Quick response roadside assistance for minor repairs and issues. Our experienced team gets you moving again fast.",
    icon: "wrench"
  },
  {
    id: 4,
    title: "Accident Recovery",
    description: "Immediate accident recovery services with care and professionalism. We handle your vehicle with the utmost respect during difficult times.",
    icon: "shield"
  },
  {
    id: 5,
    title: "Jump Starts",
    description: "Fast battery jump start service to get you moving again. Dead battery? We'll have you started in no time.",
    icon: "zap"
  },
  {
    id: 6,
    title: "Flat Battery Service",
    description: "Complete flat battery assistance including jump starts and replacement recommendations. Never be stranded again.",
    icon: "battery"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Bolton, Manchester",
    rating: 5,
    comment: "Absolutely brilliant service! Broke down at 2am on the M62 and they were with me in 25 minutes. Professional, friendly, and got me home safely. Can't recommend ADP Motors enough!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "James Patterson",
    location: "Leeds",
    rating: 5,
    comment: "Called ADP after an accident and they were incredibly helpful during a stressful time. Handled my car with care and sorted everything quickly. Five star service all the way.",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Emma Robinson",
    location: "Manchester",
    rating: 5,
    comment: "Used them three times now and every time the service has been outstanding. Fast response, fair prices, and genuinely care about helping. My go-to recovery service.",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Michael Brown",
    location: "Liverpool",
    rating: 5,
    comment: "Professionalism at its finest. Battery died in a car park and they arrived within 20 minutes. Friendly driver, quick service, and very reasonable cost. Highly recommended!",
    date: "1 week ago"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Rapid Response Time",
    description: "Average response time of under 30 minutes for emergencies. We understand that time matters when you're stranded.",
    icon: "timer"
  },
  {
    id: 2,
    title: "Fully Insured & Licensed",
    description: "Complete peace of mind with full insurance coverage and proper licensing. Your vehicle is in safe hands.",
    icon: "checkCircle"
  },
  {
    id: 3,
    title: "Experienced Professionals",
    description: "Our team of skilled professionals is trained and dedicated to excellence in vehicle recovery services.",
    icon: "award"
  },
  {
    id: 4,
    title: "Competitive Pricing",
    description: "Transparent, fair pricing with no hidden fees. Quality service doesn't have to break the bank.",
    icon: "poundSterling"
  },
  {
    id: 5,
    title: "24/7 Availability",
    description: "Day or night, rain or shine, we're here for you. Emergencies don't wait, and neither do we.",
    icon: "phone"
  },
  {
    id: 6,
    title: "Nationwide Coverage",
    description: "From Bolton to Brighton, we cover the entire UK. Wherever you are, we'll reach you.",
    icon: "map"
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/c7z8ayfo_IMG_8872.jpeg",
  towing1: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/rmucvwjm_IMG_8874.jpeg",
  towing2: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/ep2ots2o_IMG_8873.jpeg",
  truck1: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/rmucvwjm_IMG_8874.jpeg",
  truck2: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/ep2ots2o_IMG_8873.jpeg",
  professional: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/c7z8ayfo_IMG_8872.jpeg",
  recovery: "https://customer-assets.emergentagent.com/job_dedicated-towing/artifacts/ep2ots2o_IMG_8873.jpeg"
};
